<template>
  <ion-page>
    <ion-content fullscreen />
    <ion-footer class="ion-padding footer-onboarding">
      <h1>
        {{ $t('onboarding.welcome') }} {{ user.customer.data.name }}
      </h1>
      <p>{{ $t('onboarding.address') }}</p>
      <form
        ref="form"
        @submit.prevent="validate($refs.form) && onboardingContact()"
      >
        <ion-label
          color="medium"
          class="block ion-margin-top ion-margin-bottom-sm text-sm"
        >
          {{ $t('general.address') }}
        </ion-label>
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col
              size="8"
              class="ion-padding-end-sm"
            >
              <ion-input v-model="user.customer.data.street" />
            </ion-col>
            <ion-col class="ion-padding-end-sm">
              <ion-input v-model="user.customer.data.house_number" />
            </ion-col>
            <ion-col>
              <ion-input v-model="user.customer.data.house_number_addition" />
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-label
          color="medium"
          class="block ion-margin-top ion-margin-bottom-sm text-sm"
        >
          {{ $t('general.postcode_city') }}
        </ion-label>
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col
              size="4"
              class="ion-padding-end-sm"
            >
              <ion-input v-model="user.customer.data.postal_code" />
            </ion-col>
            <ion-col>
              <ion-input v-model="user.customer.data.city" />
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-label
          color="medium"
          class="block ion-margin-top ion-margin-bottom-sm text-sm"
        >
          {{ $t('general.country') }}
        </ion-label>
        <ion-select
          v-model="user.customer.data.country"
          :interface-options="{ header: $t('general.country') }"
        >
          <ion-select-option value="NL">
            {{ $t('general.country_nl') }}
          </ion-select-option>
          <ion-select-option value="BE">
            {{ $t('general.country_be') }}
          </ion-select-option>
          <ion-select-option value="DE">
            {{ $t('general.country_de') }}
          </ion-select-option>
          <ion-select-option value="LU">
            {{ $t('general.country_lu') }}
          </ion-select-option>
        </ion-select>
        <ion-label
          color="medium"
          class="block ion-margin-top ion-margin-bottom-sm text-sm"
        >
          {{ $t('general.language') }}
        </ion-label>
        <ion-select
          v-model="user.customer.data.language"
          :interface-options="{ header: $t('general.language') }"
        >
          <ion-select-option
            v-for="language in languages"
            :key="`language-${language.locale}`"
            :value="language.locale"
          >
            {{ language.name }}
          </ion-select-option>
        </ion-select>
        <template v-if="locations.length > 1">
          <ion-label
            color="medium"
            class="block ion-margin-top ion-margin-bottom-sm text-sm"
          >
            {{ $t('general.default_location') }}
          </ion-label>
          <ion-select
            v-model="user.customer.default_location_id"
            :interface-options="{ header: $t('general.default_location') }"
          >
            <ion-select-option
              v-for="location in locations"
              :key="`user-location-${location.id}`"
              :value="location.id"
            >
              {{ location.name }}
            </ion-select-option>
          </ion-select>
        </template>
        <ion-button
          expand="block"
          type="submit"
        >
          {{ $t('onboarding.continue') }}
        </ion-button>
      </form>

      <ion-grid class="ion-no-padding ion-margin-top-sm">
        <ion-row>
          <ion-col>
            <ul class="progress">
              <li />
              <li class="active" />
              <li />
              <li />
              <li />
            </ul>
          </ion-col>
          <ion-col class="ion-text-end">
            <ion-button
              fill="clear"
              color="medium"
              class="ion-no-margin ion-no-padding"
              @click="skip"
            >
              {{ $t('onboarding.skip') }}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-footer>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import {
  IonFooter, IonInput, IonSelect, IonSelectOption, modalController,
} from '@ionic/vue';
import OnboardingContact from '@/components/OnboardingContact.vue';
import { languages } from '@/plugins/i18n';
import ErrorMixin from '@/mixins/ErrorMixin';
import OnboardingMixin from '@/mixins/OnboardingMixin';
import ValidationMixin from '@/mixins/ValidationMixin';
import UserService from '@/services/User';
import LocationsService from '@/services/Locations';
import store from '@/store';

export default defineComponent({
  components: {
    IonFooter,
    IonInput,
    IonSelect,
    IonSelectOption,
  },
  mixins: [ErrorMixin, OnboardingMixin, ValidationMixin],
  data() {
    return {
      languages,
    };
  },
  computed: {
    locations: () => store.locations,
  },
  created() {
    LocationsService.getList();
  },
  methods: {
    /**
     * Go to onboarding contact.
     */
    async onboardingContact() {
      await this.handleErrors(async () => {
        if (this.locations.length === 1) {
          this.user.customer.default_location_id = this.locations[0].id;
        }

        if (this.user.customer.default_location_id) {
          await UserService.updateLocation(this.user.customer.default_location_id);
        }

        await modalController.dismiss();

        const modal = await modalController.create({
          component: OnboardingContact,
          showBackdrop: false,
          backdropDismiss: false,
        });
        await modal.present();
      });
    },
  },
});
</script>

<style scoped>
ion-content {
  --background: none;
}
</style>
